import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { routes } from '../data/site';
export function ProofStrip() {
  return <section aria-label="D.A. Alexander at a glance" className="border-b border-charcoal/10 bg-stone" data-id="element-214" data-mp="3g8e4pzi8n6c8">
      <div className="site-container grid divide-y divide-charcoal/15 md:grid-cols-3 md:divide-x md:divide-y-0" data-id="element-215" data-mp="3bbfa7funwxdi">
        <div className="flex items-center justify-center px-5 py-5 md:px-6 md:py-6" data-id="element-216" data-mp="369pyrz3j2how">
          <div className="w-fit max-w-full text-left" data-id="element-217" data-mp="7tnfhtp55zbm">
            <p className="flex items-baseline gap-2.5 text-olive" data-id="element-218" data-mp="2ukkz36sfbhw">
              <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-moss" data-id="element-219" data-mp="2t9gf15ipzpq">Since</span>
              <span className="font-display text-[44px] font-medium leading-[0.9]" data-id="element-220" data-mp="3pzsbmscir8fe">1978</span>
            </p>
            <p className="mt-2 text-[14px] leading-relaxed text-charcoal/75" data-id="element-221" data-mp="2ilyo0zxmycpq">Landscape design, installation &amp; care</p>
          </div>
        </div>

        <a href={routes.awards} className="focus-ring group flex items-center justify-center px-5 py-5 md:px-6 md:py-6" data-id="element-222" data-mp="2ej20qvx5hsfg">
          <div className="w-fit max-w-full text-left" data-id="element-223" data-mp="3g9ktakrqcnhy">
            <p className="font-display text-[26px] font-medium leading-tight text-olive" data-id="element-224" data-mp="3g91n21bfznjr">Award-winning work</p>
            <p className="mt-2 inline-flex items-center gap-2 text-[14px] leading-relaxed text-charcoal/75 transition-colors duration-150 group-hover:text-olive" data-id="element-225" data-mp="32c4lb4tsclo3">
              Recognized by MGIA and HBA
              <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1" strokeWidth={1.5} aria-hidden="true" data-id="element-226" data-mp="2sifem8xj0198" />
            </p>
          </div>
        </a>

        <div className="flex items-center justify-center px-5 py-5 md:px-6 md:py-6" data-id="element-227" data-mp="2nloyxmpmv7oc">
          <div className="w-fit max-w-full text-left" data-id="element-228" data-mp="29mpbgiduwytr">
            <p className="font-display text-[26px] font-medium leading-tight text-olive" data-id="element-229" data-mp="2ekhby0skht9k">Four-season service</p>
            <p className="mt-2 text-[14px] leading-relaxed text-charcoal/75" data-id="element-230" data-mp="k4sfuikcxwkb">For commercial properties &amp; HOAs</p>
          </div>
        </div>
      </div>
    </section>;
}